<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Tax Rate</h4>
    <button type="button" class="close" aria-label="Close"
            [disabled]="savingOption"
            [class.disabled]="savingOption"
            (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="nameInput">Name</label>
      <input id="nameInput" type="text" class="form-control" name="name"
             required
             [(ngModel)]="opt.name">
      <small class="form-text text-muted">
        This name is for staff use only, and is not displayed to the customer.
      </small>
      <div class="form-text text-danger">{{ errors.name }}</div>
    </div>

    <div class="form-group">
      <label for="banner_image">
        Image
      </label>
      <form>
      <input id="banner_image"
             class="mb-2 d-block"
             type="file" accept=".png,.jpg,.jpeg"
             (change)="attachImageFile($event)"
             [disabled]="savingOption"
             [class.disabled]="savingOption">
      </form>
      <div class="d-block">
        <img *ngIf="opt.image"
             [src]="opt.image"
             width="200" height="100"
             class="d-inline"
             style="border: 1px solid black">
        <div *ngIf="!opt.image"
             class="d-flex justify-content-center align-items-center"
             style="background-color: #d6d6d6; width: 200px; height: 100px;">
          <div>No image selected</div>
        </div>
        <button type="button" class="btn btn-sm btn-secondary d-inline ml-2 mt-2"
                *ngIf="opt.image !== null"
                (click)="imageFileData = null; opt.image = null;">
          Remove Image
        </button>
      </div>
      <small class="form-text text-muted">
        This must be a .png or .jpeg file no more than 4 MB in size, with a 2:1 aspect ratio. We recommend the image be 300 by 150 pixels.
      </small>
      <div class="text-danger">
        {{ errors.image }}
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            [disabled]="savingOption"
            [class.disabled]="savingOption"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            (click)="saveOption()"
            *ngIf="!savingOption">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="savingOption">
      Loading...
    </button>
  </div>

</ng-container>
